export default "__VITE_ASSET__DpTaWGdI__"